import { Box, Button, Stack, Tooltip } from '@mui/material'
import React from 'react'
import { UseFormHandleSubmit } from 'react-hook-form'
import { getImageSrc } from '../../../../../helpers/getImageSrc'
import { Mode } from '../NewServiceResultsDrawer'
import { ActiveOrder, ServiceCenterForm } from '../types/NewDrawers.types'

interface ActionButtonsProps {
  mode: Mode
  fromExistedRequest: boolean
  isValid: boolean
  isSending: boolean
  isLinking: boolean
  isCreating: boolean
  selectedServiceRequest: ActiveOrder | null
  showContinueBtn: boolean
  checked: boolean
  diagnosticData: any
  serialResponse: any
  serialNum: string | null
  errors: any
  isPending: boolean
  handleSubmit: UseFormHandleSubmit<ServiceCenterForm>
  onSubmit: (data: ServiceCenterForm) => void
  onSendExistedRequest: () => void
  linkToServiceRequest: () => void
  createWithLinkToServiceRequest: () => void
  setMode: (mode: Mode) => void
  onSerialErrorBtn: () => void
  onSerialCheck: () => void
  onBack: () => void
  serialResponseError: any
}

const ToServiceActionButtons: React.FC<ActionButtonsProps> = ({
  mode,
  fromExistedRequest,
  isValid,
  isSending,
  isLinking,
  isCreating,
  selectedServiceRequest,
  showContinueBtn,
  checked,
  diagnosticData,
  serialResponse,
  serialNum,
  errors,
  isPending,
  handleSubmit,
  onSubmit,
  onSendExistedRequest,
  linkToServiceRequest,
  createWithLinkToServiceRequest,
  setMode,
  onSerialErrorBtn,
  onSerialCheck,
  onBack,
  serialResponseError,
}) => {
  return (
    <Stack sx={{ paddingX: '16px' }} spacing={'14px'}>
      {mode === 'checked' && !fromExistedRequest && (
        <Button
          type='submit'
          disabled={!isValid}
          variant='contained'
          sx={{ paddingX: '8px !important' }}
          onClick={handleSubmit(onSubmit)}
        >
          Проверить и отправить в сервис-центр
        </Button>
      )}

      {mode === 'checked' && fromExistedRequest && (
        <Button
          type='button'
          disabled={!isValid}
          onClick={onSendExistedRequest}
          variant='contained'
          loading={isSending}
          sx={{ paddingX: '8px !important' }}
        >
          отправить в сервис-центр
        </Button>
      )}

      {['has-closed', 'has-active'].includes(mode) && (
        <Button
          type='button'
          onClick={
            fromExistedRequest
              ? linkToServiceRequest
              : createWithLinkToServiceRequest
          }
          variant='contained'
          disabled={!selectedServiceRequest}
          sx={{ paddingX: '8px !important' }}
          loading={isLinking || isCreating}
        >
          Связать заявку с выбранной
        </Button>
      )}

      {mode === 'has-closed' && (
        <Button
          type='button'
          onClick={() => setMode('checked')}
          variant='contained'
          disabled={!!selectedServiceRequest}
          sx={{ paddingX: '8px !important' }}
        >
          {fromExistedRequest
            ? 'Продолжить создание заявки'
            : 'Продолжить создание новой заявки'}
        </Button>
      )}

      {showContinueBtn && (
        <Button
          type='button'
          onClick={onSerialErrorBtn}
          variant='contained'
          sx={{ paddingX: '8px !important' }}
        >
          продолжить
        </Button>
      )}

      {!checked && (
        <Tooltip
          placement='top'
          title={
            'Заявка не может быть отправлена в сервис-центр, отсутствует Id оборудования'
          }
          disableHoverListener={!!diagnosticData?.equipmentId}
        >
          <Box>
            <Button
              type='button'
              disabled={
                !diagnosticData?.equipmentId ||
                getIsCheckBtnDisabled(
                  serialResponseError,
                  serialResponse,
                  serialNum
                ) ||
                !!errors?.serialNumber
              }
              variant='contained'
              sx={{ width: '100%' }}
              onClick={onSerialCheck}
              loading={!!serialNum && isPending}
            >
              Проверить данные в сервис-центре
            </Button>
          </Box>
        </Tooltip>
      )}
      <Button variant='outlined' onClick={onBack}>
        <img
          alt={'Назад'}
          src={getImageSrc('arrow-left-blue')}
          style={{ marginRight: '4px' }}
        />
        Назад
      </Button>
    </Stack>
  )
}

const getIsCheckBtnDisabled = (
  serialResponseError: any,
  serialResponse: any,
  serialNum: string | null
) =>
  Boolean(
    (serialResponseError || serialResponse?.validationErrors) && serialNum
  )

export default ToServiceActionButtons
